import { useContext } from "react";
import { useQuery } from "react-query";
import AppContext from "../appContext";
import * as api from "../services";

export default function useTags() {
  const {
    app: {
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { data: tags } = useQuery(["tags", projectId, sessionId], () =>
    api.getTags({ projectId, sessionId })
  );
  return { tags };
}
